<template>
	<!-- Vue Material Tab -->
	<!-- https://vuematerial.io/components/tabs -->
	<md-tab
		:md-icon="icon"
		:md-label="label"
	>
		<slot/>
	</md-tab>
</template>

<script>
export default {
	name: "Tab",
	props: {
		icon: {
			type: String,
			default: null,
			required: false
		},
		label: {
			type: String,
			default: "",
			required: false
		}
	}
};
</script>
